import React, { useEffect, useRef, useState } from 'react'
import { FaSearch } from "react-icons/fa";
import { IoMdAdd } from "react-icons/io";
import adminServices from '../../services/AdminServices';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import Loading from '../feedback/Loading';
import FetchError from '../feedback/FetchError';
import Pagination from '../nav/Pagination';
import Empty from '../feedback/Empty';
import UserTableRow from '../admin/UserTableRow';
import UserModal from '../admin/UserModal';
import UserStats from '../admin/UserStats';

function UsersTab() {
    const [searchParams, setSearchParams] = useSearchParams()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState()
    const [users, setUsers] = useState()
    const [action, setAction] = useState(0)
    const [activeUser, setActiveUser] = useState()
    const searchInputRef = useRef();
    const navigate = useNavigate();
    const location = useLocation();
    const currentOrdering = searchParams.get('ordering') || '';

    useEffect(() => {
        getUsers()
    }, [])
    useEffect(() => { }, [error])
    useEffect(() => { }, [users])
    useEffect(() => {
        const params = searchParams.toString()
        getUsers(params)
    }, [searchParams])

    const getUsers = (params) => {
        setError()
        setLoading(true)
        adminServices.getUsers(params ? `?${params}` : '').then(
            res => {
                setUsers(res.data)
                setLoading(false)
            },
            err => {
                console.log(err);
                setError(err)
                setLoading(false)
            }
        )
    }
    function changePageParam(page) {
        if (page) {
            setSearchParams((params) => {
                params.set("page", page)
                return params
            })
        } else {
            setSearchParams((params) => {
                params.delete("page")
                return params
            })
        }
    }
    useEffect(() => { }, [action])
    useEffect(() => { }, [activeUser])

    function openModal(action, user) {
        const openBtn = document.getElementById("user-create-open-btn")
        if (action === 0) {
            setAction(0)
        }
        if (action === 1) {
            setAction(1)
            setActiveUser(user)
        }
        openBtn.click()
    }


    const handleSearch = (e) => {
        if (e.key === 'Enter') {
            const query = e.target.value.trim();
            setSearchParams(prev => {
                const newParams = new URLSearchParams(prev);
                if (query) {
                    newParams.set('search', query);
                } else {
                    newParams.delete('search');
                }
                newParams.delete('page');
                return newParams;
            });
        }
    };

    const updateURL = (newParams, scroll = false) => {
        const newPath = {
            pathname: location.pathname,
            search: newParams.toString(),
        };
        navigate(newPath, { replace: true, state: { scroll } });
    };

    const handleOrderingChange = (e) => {
        const value = e.target.value;
        const params = new URLSearchParams(searchParams);

        if (value) {
            params.set('ordering', value);
        } else {
            params.delete('ordering');
        }
        params.delete('page');

        updateURL(params);
    };
    return (
        <div className='space-y-6'>
            <UserStats />
            <div className="flex justify-between items-center">
                <div>
                    <h1 className="text-2xl font-bold text-gray-800">Users</h1>
                    <p className="text-sm text-gray-600 dark:text-gray-300 mb-4 sm:mb-0">
                        Showing {users?.results?.length || 0} of {users?.count || 0} users
                    </p>
                </div>
                <button
                    onClick={() => openModal(0)}
                    className="w-full md:w-auto mt-4 md:mt-0 flex items-center justify-center px-4 py-2 bg-primary text-white font-medium rounded-lg hover:bg-red-800 transition-colors duration-200">
                    <span className="material-icons mr-2"><IoMdAdd /></span>
                    Add New User
                </button>
            </div>
            {/* <hr className='mb-6' /> */}
            <div className="space-y-6">
                <div className="flex flex-col md:flex-row items-center justify-between">
                    <div className="relative w-full md:w-80">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                            <FaSearch />
                        </span>
                        <input
                            ref={searchInputRef}
                            className="w-full pl-10 pr-10 py-2 border rounded-lg focus:ring-primary focus:border-primary"
                            placeholder="Search users by name or email ..."
                            type="text"
                            onKeyDown={handleSearch}
                            defaultValue={searchParams.get('search') || ''}
                        />
                    </div>
                    <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-4 sm:mb-0">
                        <p className="whitespace-nowrap">Sort By:</p>
                        <select
                            className="select w-full sm:w-auto border"
                            value={currentOrdering}
                            onChange={handleOrderingChange}
                        >
                            <option value="">Default</option>
                            <option value="-creation_time">Newest</option>
                            <option value="creation_time">Oldest</option>
                            <option value="full_name">Name: A to Z</option>
                            <option value="-full_name">Name: Z to A</option>
                            <option value="email">Email: A to Z</option>
                            <option value="-email">Email: Z to A</option>
                        </select>
                    </div>

                </div>
                <UserModal
                    getUsers={getUsers}
                    action={action}
                    activeUser={activeUser}
                />

                <div className="bg-white dark:bg-slate-800 rounded-lg shadow-md overflow-hidden border border-border-light dark:border-border-dark">
                    <div className="p-3">
                        {loading ? (
                            <div className='py-9'>
                                <Loading />
                            </div>
                        ) : (
                            <div>
                                {error ? (
                                    <div><FetchError error={error} /></div>
                                ) : (
                                    <div>
                                        <div className='overflow-x-auto'>
                                            <table className="table table-compact table-zebra w-full">
                                                <thead>
                                                    <tr>
                                                        <th>User</th>
                                                        <th>User Type</th>
                                                        <th className='hidden md:table-cell'>Is Verified</th>
                                                        <th className='hidden md:table-cell'>Created</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {users?.results?.map((user, idx) => (
                                                        <UserTableRow
                                                            key={idx}
                                                            user={user}
                                                            openModal={openModal}
                                                        />
                                                    ))}
                                                </tbody>
                                            </table>
                                            {users?.count < 1 ? (
                                                <Empty objectName={"Users"} />
                                            ) : null}
                                            {users ? (
                                                <div className='mt-8 flex justify-center'>
                                                    <Pagination
                                                        count={users?.count}
                                                        next={users?.next}
                                                        previous={users?.previous}
                                                        changePageParam={changePageParam}
                                                    />
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UsersTab